import React from 'react';
import { CUIText, Image } from '@dotcom/crown-ui';
import { InstructionStepProps } from '../../wam-instructions-drawer/wam-instructions-drawer-types';
import styles from '../wam-instructions-menu.module.scss';

export const InstructionStepCompact = ({ title, text, imageUrl, stepNumber }: InstructionStepProps) => (
  <div className={styles['instruction-step']}>
    <div className={styles['instruction-image-wrapper']}>
      <div className={styles['image-clip']}>
        <Image src={imageUrl} className={styles['instruction-image']} alt={title} />
      </div>
      <CUIText as="span" size="small" className={styles['badge']}>
        {stepNumber}
      </CUIText>
    </div>
    <div className={styles['instruction-text']}>
      <CUIText variant="h5" className={styles['step-title']}>
        {title}
      </CUIText>
      <CUIText variant="body" className={styles['step-description']}>
        {text}
      </CUIText>
    </div>
  </div>
);
